import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::store
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:41
* @route '/bookings/{booking}/change-room'
*/
export const store = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/bookings/{booking}/change-room',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::store
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:41
* @route '/bookings/{booking}/change-room'
*/
store.url = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { booking: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'booking_reference' in args) {
        args = { booking: args.booking_reference }
    }

    if (Array.isArray(args)) {
        args = {
            booking: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        booking: typeof args.booking === 'object'
        ? args.booking.booking_reference
        : args.booking,
    }

    return store.definition.url
            .replace('{booking}', parsedArgs.booking.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::store
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:41
* @route '/bookings/{booking}/change-room'
*/
store.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::store
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:41
* @route '/bookings/{booking}/change-room'
*/
const storeForm = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\Bookings\RoomChangeController::store
* @see app/Http/Controllers/Admin/Bookings/RoomChangeController.php:41
* @route '/bookings/{booking}/change-room'
*/
storeForm.post = (args: { booking: string | number | { booking_reference: string | number } } | [booking: string | number | { booking_reference: string | number } ] | string | number | { booking_reference: string | number }, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

const changeRoom = {
    store: Object.assign(store, store),
}

export default changeRoom